import styled from 'styled-components';
import { containers } from '@comicrelief/component-library';

const Wrapper = styled.div`
  background: ${({ theme }) => theme.color('grey_light')};
  display: flex;
  flex-direction: column;
`;

const Container = styled.article.attrs({
  'data-test': 'person'
})`
  background: ${({ theme }) => theme.color('white')};
  width: 100%;
  max-width: ${containers.small};
  margin: 1rem auto;
  padding: 1rem;
  @media ${({ theme }) => theme.allBreakpoints('M')} {
    padding: 2rem 4rem;
  }
`;

const Header = styled.header`
  padding-top: 2rem;
  text-align: center;
  width: 100%;
  max-width: ${containers.small};
  margin: 0 auto;
`;

const Image = styled.div`
  width: 100%;
  margin: 2rem auto;

  @media ${({ theme }) => theme.allBreakpoints('L')} {
    width: 130%;
    margin-left: -15%;
  }
`;

export {
  Wrapper, Container, Header, Image
};
